export const STRIPE_VALIDATION_ERROR_MAP = {
  defaultMessage: 'Invalid data',

  incomplete_number: 'Card number is incomplete',
  invalid_number: 'Card number is invalid',

  incomplete_expiry: 'Date is incomplete',
  invalid_expiry_month_past: 'Date is in the past',
  invalid_expiry_year_past: 'Year is in the past',

  incomplete_cvc: 'Code is incomplete',
};

export const STRIPE_ELEMENT_CLASSES = {
  classes: {
    base: 'stripe-element',
    focus: 'stripe-element--focus',
  },
};

export const STRIPE_ELEMENT_STYLES = {
  style: {
    base: {
      color: '#162958',
      fontFamily: 'D-DIN, Helvetica, Arial, sans-serif',
      fontSize: '18px',
      lineHeight: '24px',

      '::placeholder': {
        color: '#d5dae6',
      },
    },

    invalid: {
      color: '#162958',
      iconColor: '#D92020',
    },
  },
};

export const STRIPE_ELEMENT_OPTIONS = {
  ...STRIPE_ELEMENT_CLASSES,
  ...STRIPE_ELEMENT_STYLES,
};
